/**
 * BU header — push-down panels (mobile menu + inline search).
 *
 * Recreates the Sloth Hiking Club behaviour (BUILD-PLAN.md §C·P1, spec 08 §3):
 *  - every `[data-bu-toggle="<id>"]` button flips the `hidden` attribute on that element
 *    and keeps its own `aria-expanded` in sync;
 *  - when a panel opens, its first real (non-hidden) `<input>` is focused — this is what
 *    puts the cursor in the search box;
 *  - the menu and search panels are independent: both may be open at once;
 *  - Escape closes every open panel;
 *  - this script never swaps the ≡ glyph. Aid 2026-10-04 (QA round 1): the menu button now carries both
 *    a ≡ and an × and CSS in bu-header.liquid shows the × while aria-expanded="true" (ORIGINAL: Sloth parity,
 *    the ≡ never changed). Comment-only edit; behaviour unchanged.
 *
 * Why event delegation instead of binding per button: the theme editor re-renders the
 * section when Joe edits a setting, which would drop per-button listeners. A single
 * document-level listener survives that.
 */

function panelFor(button) {
  const id = button.getAttribute('data-bu-toggle');
  return id ? document.getElementById(id) : null;
}

function setOpen(button, panel, open) {
  panel.hidden = !open;
  button.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (open) {
    const input = panel.querySelector('input:not([type="hidden"])');
    if (input) input.focus();
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-bu-toggle]');
  if (!button) return;
  const panel = panelFor(button);
  if (!panel) return;
  event.preventDefault();
  setOpen(button, panel, panel.hidden);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-bu-toggle]').forEach((button) => {
    const panel = panelFor(button);
    if (panel && !panel.hidden) setOpen(button, panel, false);
  });
});
